import React, { Fragment } from "react";
import {
  Grid,
  Container,
  Box,
  Typography,
  Modal,
  Button,
} from "@material-ui/core";
import { formatLocaleDate } from "../utils/dateUtils";
import StaffRating from "./support/staff/StaffRating";
import ButtonLoader from "./ButtonLoader";
export default function ReservationChangeModal({
  modal,
  loading,
  setModal,
  modalData,
  changeReservationDate,
}) {
  return (
    <Modal
      open={modal}
      onClose={() => {
        !loading && setModal(false);
      }}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Box className="modal-wrapper">
        <Box className="modal">
          <div className="modal-heading">
            <div className="modal-heading-text">
              <Typography className="modal-title">予約日時の変更</Typography>
            </div>
            <button
              className="back-btn"
              onClick={() => !loading && setModal(false)}
            >
              閉じる
            </button>
          </div>
          <div className="modal-body">
            <div>
              <Typography
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "800",
                  color: "var(--primary-color)",
                }}
              >
                予約日時を <br />
                {formatLocaleDate(modalData.date)}{" "}
                {modalData.time && modalData.time.replace("-", ":")}
                <br /> に変更しますか？
              </Typography>
              <Typography>よろしければボタンを押してください。</Typography>
              <Typography
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "800",
                  color: "var(--primary-color)",
                }}
              >
                {modalData.productName} ({modalData.ticketNumber})
              </Typography>
              <Box className="agent-details">
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                  style={{ textAlign: "left", marginBottom: "2rem" }}
                >
                  <Grid
                    item
                    md={12}
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Grid item md={"auto"}>
                      {modalData?.staffInfo?.staffNickname == "指名なし" ? (
                        <img
                          src={"/images/staff_free.png"}
                          style={{
                            height: "80px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img
                          src={
                            modalData?.staffInfo?.staffImageUrl ||
                            "/images/staff_noimage.png"
                          }
                          style={{
                            height: "80px",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </Grid>
                    <Grid item md={"auto"}>
                      <Typography style={{ marginBottom: "0" }}>
                        {modalData?.staffInfo?.staffNickname}
                      </Typography>
                      <Typography style={{ marginBottom: "0" }}>
                        {modalData?.staffInfo?.staffAge
                          ? modalData.staffInfo.staffAge + ", "
                          : ""}
                        {modalData?.staffInfo?.staffGender ? (
                          <Fragment>
                            {modalData?.staffInfo?.staffGender}
                          </Fragment>
                        ) : (
                          ""
                        )}
                      </Typography>
                      {modalData?.staffInfo?.averageScore && (
                        <StaffRating
                          rating={modalData?.staffInfo?.averageScore}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              {loading && <div className="button-overlay"></div>}
              <Button
                variant="contained"
                color="primary"
                style={{ padding: "6px 5rem", marginRight: "10px" }}
                disabled={loading}
                onClick={() => {
                  changeReservationDate(
                    modalData.staffInfo,
                    modalData.date,
                    modalData.time
                  );
                }}
              >
                {loading ? <ButtonLoader btnColor="light" /> : "確定"}
              </Button>
            </div>
          </div>
        </Box>
      </Box>
    </Modal>
  );
}
